import 'ol/ol.css';
// import Mercator from './mercator';

import MapFusion from './mapFusion';
import MapMethod from './mapMethod';

// const projection = new Mercator('EPSG:4326');

/**
 * @private
 * 預設地圖參數
 */
const DefaultMapConfig = {
    // 地圖ID
    mapId: 'geoMap',
    // 地圖設定
    options: {
        projection: 'EPSG:3857',
        center: [13432135.60329341, 2777811.52867679],
        // projection: 'EPSG:4326',
        // center: [120.6378699, 24.1629449],
        zoom: 14,
        // resolutions: projection.resolutions,
        // 全螢幕
        isFullScreen: false,
        isDoubleMap: false,
        cluster: {
            // 是否依數量來決定叢集樣式
            byCount: true,
            // 最小半徑
            minRadius: 10,
            // 最大半徑
            maxRadius: 40,
            // 該圖層的半徑
            radius: [5, 7, 9, 11, 14, 18, 22, 26, 30, 35, 40],
        },
        // 預設的UI disable
        disableDefaultUI: false,
        /**
         * panel控制項，那些要出現
         * @summary
         * state: 狀態
         * layers: 圖層
         * position: 定位
         * draw: 標繪
         * measure: 量測
         * others: 其他
         */
        panelControl: [],
    },
    // 底圖設定
    baseLayers: [
        {
            name: '通用版電子地圖',
            type: 'nlsc',
            visible: true,
        },
        {
            name: '通用版正射影像',
            type: 'ortho',
            visible: false,
        },
        {
            name: 'OpenStreetMap',
            type: 'osm',
            visible: false,
        },
    ],
};

/**
 * @private
 * 回傳完整的地圖參數
 * @param {Object} defaultMapConfig 預設地圖參數
 * @param {Object} config 地圖參數
 * @returns {Object} c 地圖設定參數
 */
function _getConfig(defaultMapConfig, config) {
    const c = { ...defaultMapConfig, ...config };
    // options如果有值再次重取
    if (config && config.options) {
        const ops = { ...defaultMapConfig.options, ...config.options };
        ops.center = [ops.center.lng, ops.center.lat];
        c.options = ops;
    }
    // mixins如果有值再次重取
    if (config && config.mixins) {
        let mixins = {};
        config.mixins.forEach((item) => {
            mixins = { ...mixins, ...item };
        });
        c.mixins = mixins;
    }
    return c;
}

/**
 * 地圖物件，提供指定容器ID建立地圖
 * @param {object} config 地圖設定參數
 * @returns {object} map 地圖物件
 */
export default class GMap {
    constructor(config) {
        // 地圖參數
        this._mapConfig = _getConfig(this.constructor.DefaultMapConfig, config);

        // 地圖Element加入geo-map class，避免污染其他樣式
        document.getElementById(this._mapConfig.mapId).classList.add('geo-map');

        // 判斷地圖是否全螢幕
        if (this._mapConfig.options.isFullScreen) {
            document
                .getElementById(this._mapConfig.mapId)
                .classList.add('geo-fullScreen');
        }

        if (this._mapConfig.options.isDoubleMap) {
            document
                .getElementById(this._mapConfig.mapId)
                .classList.add('geo-doublemap');
        }

        // 地圖初始
        const map = new MapFusion(this._mapConfig);
        this.olmap = map.olmap;
        this.baseLayers = map.baseLayers;
        this.customLayers = {};

        // 地圖預設方法與使用者傳入的方法組成methods，方便調用
        const defaultMixin = MapMethod(this);
        this.methods = { ...defaultMixin, ...this._mapConfig.mixins };

        // 判斷是否使用預設的UI，地圖面板初始
        if (!this._mapConfig.options.disableDefaultUI) {
            // 取用 panelMethods
            // const panelMethods = MapPanel(this);
            // panelMethods.panelInit(this.olmap);
        }
    }

    // Getters

    static get DefaultMapConfig() {
        return DefaultMapConfig;
    }

    // Public

    // showConfig() {
    //     return this._mapConfig;
    // }
}

// window.GMap = GMap;
